"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = Tooltip;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Tooltip({
  children,
  hidden,
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledContainer, {
    "data-testid": testId,
    hidden: hidden
  }, /*#__PURE__*/_react.default.createElement(_styled.StyledContent, null, children), /*#__PURE__*/_react.default.createElement(_styled.StyledArrow, {
    role: "none"
  }));
}